import { render, staticRenderFns } from "./s-list.vue?vue&type=template&id=63fc5e14&"
import script from "./s-list.vue?vue&type=script&lang=js&"
export * from "./s-list.vue?vue&type=script&lang=js&"
import style0 from "./s-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports